export default "__VITE_ASSET__qM8ep56t__"